import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { appModal } from "../../helpers/interactions";

const Alert = ({ layout: { alert } }) => {
  return (
    <div
      id="Alert"
      aria-labelledby="Alert-title"
      data-bs-backdrop="static"
      className="modal fade modal-fade-in-scale-up"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 className="modal-title" id="Alert-title">
              {alert.title}
            </h4>
          </div>
          <div className="modal-body">
            {alert.body}
            <div className="app-form-group form-material margin-bottom-0">
              <button
                type="submit"
                onClick={close(alert.callback)}
                className="app-btn btn-round app-btn--info waves-effect waves-light"
              >
                {alert.confirm || "Ok"}
              </button>{" "}
              <button type="submit" onClick={close()} className="app-btn btn-round waves-effect waves-light">
                {alert.cancel || "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Alert.propTypes = {
  layout: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    layout: state.layout,
  };
}

export default connect(mapStateToProps)(Alert);

function close(callback) {
  return (_e) => {
    callback?.();
    appModal("#Alert", "hide");
  };
}
